import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Only generic presentation is delegated; session and plan enforcement always remain global. */
export const ERROR_PRESENTATION_OWNER = new HttpContextToken<'global' | 'component'>(() => 'global');

/**
 * Marks a request whose 404 responses are handled by the calling component itself
 * (e.g. an edit/detail screen that renders its own "not found" state), so the global
 * http error interceptor must not raise the generic "Not Found" toast for it.
 */
export const SUPPRESS_NOT_FOUND_TOAST = new HttpContextToken<boolean>(() => false);

/** Convenience builder for a request context that suppresses the generic not-found toast. */
export function suppressNotFoundToastContext(): HttpContext {
  return new HttpContext().set(SUPPRESS_NOT_FOUND_TOAST, true);
}

/**
 * Marks a request whose 403 responses are expected and handled by the caller, so the global
 * http error interceptor must not raise the generic "Forbidden" toast for it.
 *
 * Only for optional, permission-dependent chrome that the screen degrades without — SPEED-865:
 * the bill inbox forwarding panel, which a profile may simply not be entitled to. Never use it
 * for a request the screen actually depends on. Subscription-expiry 403s are classified before
 * this check, so they still toast and redirect.
 */
export const SUPPRESS_FORBIDDEN_TOAST = new HttpContextToken<boolean>(() => false);

/** Convenience builder for a request context that suppresses the generic forbidden toast. */
export function suppressForbiddenToastContext(): HttpContext {
  return new HttpContext().set(SUPPRESS_FORBIDDEN_TOAST, true);
}
